const WEB_TERMINAL_ID_KEY = "vmassWebPrintTerminalId";
const WEB_PRINT_MODE_KEY = "vmassWebPrintMode";
const WEB_PRINT_DOCUMENT_TYPE_KEY = "vmassWebPrintDocumentType";

const randomPart = () => Math.random().toString(36).slice(2, 10);

export const createWebPrintTerminalId = () =>
  window.crypto && typeof window.crypto.randomUUID === "function"
    ? window.crypto.randomUUID()
    : `web-${Date.now().toString(36)}-${randomPart()}-${randomPart()}`;

export const getOrCreateWebPrintTerminalId = () => {
  const query = new URLSearchParams(window.location.search);
  const urlTerminalId = query.get("vmass_print_terminal");
  const urlDocumentType = query.get("vmass_print_type");
  if (urlDocumentType === "customer" || urlDocumentType === "kitchen") {
    localStorage.setItem(WEB_PRINT_DOCUMENT_TYPE_KEY, urlDocumentType);
  }
  if (urlTerminalId) {
    localStorage.setItem(WEB_TERMINAL_ID_KEY, urlTerminalId);
    return urlTerminalId;
  }

  const existing = localStorage.getItem(WEB_TERMINAL_ID_KEY);
  if (existing) return existing;

  const id = createWebPrintTerminalId();
  localStorage.setItem(WEB_TERMINAL_ID_KEY, id);
  return id;
};

export const getWebPrintMode = () =>
  localStorage.getItem(WEB_PRINT_MODE_KEY) === "kiosk-silent"
    ? "kiosk-silent"
    : "dialog";

export const setWebPrintMode = (mode) => {
  const normalized = mode === "kiosk-silent" ? "kiosk-silent" : "dialog";
  localStorage.setItem(WEB_PRINT_MODE_KEY, normalized);
  return normalized;
};

export const getWebPrintDocumentType = () => {
  const type = localStorage.getItem(WEB_PRINT_DOCUMENT_TYPE_KEY);
  return type === "kitchen" ? "kitchen" : "customer";
};

export const setWebPrintDocumentType = (type) => {
  const normalized = type === "kitchen" ? "kitchen" : "customer";
  localStorage.setItem(WEB_PRINT_DOCUMENT_TYPE_KEY, normalized);
  return normalized;
};

export const buildWindowsKioskLauncher = ({
  browser = "edge",
  url,
  terminalId,
}) => {
  const executable =
    browser === "chrome" ? "chrome.exe" : "msedge.exe";
  const paths =
    browser === "chrome"
      ? [
          "%ProgramFiles%\\Google\\Chrome\\Application\\chrome.exe",
          "%ProgramFiles(x86)%\\Google\\Chrome\\Application\\chrome.exe",
          "%LocalAppData%\\Google\\Chrome\\Application\\chrome.exe",
        ]
      : [
          "%ProgramFiles(x86)%\\Microsoft\\Edge\\Application\\msedge.exe",
          "%ProgramFiles%\\Microsoft\\Edge\\Application\\msedge.exe",
          "%LocalAppData%\\Microsoft\\Edge\\Application\\msedge.exe",
        ];

  const findCommands = paths
    .map(
      (candidate) =>
        `if exist "${candidate}" set "BROWSER_PATH=${candidate}"`,
    )
    .join("\r\n");
  const profilePath = `%LocalAppData%\\VMASS\\WebPrint\\${terminalId}`;

  return [
    "@echo off",
    "setlocal",
    'set "BROWSER_PATH="',
    findCommands,
    'if not defined BROWSER_PATH (',
    `  echo Khong tim thay ${executable}. Vui long cai dat trinh duyet va thu lai.`,
    "  pause",
    "  exit /b 1",
    ")",
    `start "" "%BROWSER_PATH%" --app="${url}" --start-fullscreen --kiosk-printing --no-first-run --user-data-dir="${profilePath}"`,
    "endlocal",
    "",
  ].join("\r\n");
};

export const downloadWindowsKioskLauncher = (options) => {
  const content = buildWindowsKioskLauncher(options);
  const blob = new Blob([content], {
    type: "application/x-bat;charset=utf-8",
  });
  const href = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = href;
  anchor.download = `VMASS-WebPrint-${options.browser}.cmd`;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(href);
};
